"use client";

import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    question: "What if I have to miss a game night?",
    answer:
      "Life happens—we're adults here, we get it. Most leagues allow 1-2 absences per season. Just give your team a heads up. For planned stuff (vacation, kid's recital, whatever), our scheduling tools help teams find alternate times or arrange subs.",
  },
  {
    question: "I'm not that good. Will I get wrecked?",
    answer:
      "Nope. Each league is organized by skill tier, from \"I just want chill games\" to \"I take this seriously.\" You'll indicate your level during signup and we'll match you with similar players. The goal is competitive games, not stomps.",
  },
  {
    question: "How do regional communities work?",
    answer:
      "We organize by geography (Northeast, Southeast, Midwest, West Coast, etc.) so you're playing with people in similar time zones. Makes scheduling easier and opens doors to meetups. Many regions do in-person events at least once per season—turns out it's cool to hang with your squad IRL.",
  },
  {
    question: "What equipment do I need?",
    answer:
      "Just the game and decent internet. We play on whatever platform the game supports—PC, PlayStation, Xbox, Switch. Voice chat is required for team games (we use Discord). That headset you already have? That works.",
  },
  {
    question: "How long is a season?",
    answer:
      "8 weeks total: 6 weeks regular season, 2 weeks playoffs. Most leagues have 1-2 game nights per week, with sessions running 1-2 hours. We schedule around adult life—typically evenings after 8pm local time.",
  },
  {
    question: "Why pay when I could just find a random Discord group?",
    answer:
      "You could! But you've probably tried that. Random groups have massive flake rates—people commit, then ghost. Our small fee creates accountability. When you pay, you show up. Plus, regional focus means your teammates aren't random internet strangers—they're people you could actually grab a beer with.",
  },
];

export function FAQSection() {
  return (
    <section id="faq" className="py-24 md:py-32">
      <div className="mx-auto max-w-3xl px-6 lg:px-8">
        <div className="text-center">
          <h2 className="text-3xl font-bold tracking-tight text-foreground sm:text-4xl md:text-5xl">
            Questions? <span className="text-primary text-glow-cyan">Answers.</span>
          </h2>
          <p className="mt-4 text-lg text-muted-foreground">
            The stuff people usually ask before signing up.
          </p>
        </div>

        <Accordion type="single" collapsible className="mt-12">
          {faqs.map((faq, index) => (
            <AccordionItem 
              key={index} 
              value={`item-${index}`}
              className="border-border data-[state=open]:border-primary/30"
            >
              <AccordionTrigger className="text-left text-foreground hover:text-primary transition-colors py-6">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground leading-relaxed pb-6">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
